import { useAuthentication } from "authentication/AuthenticationContext";
import { useNavigate, Link } from "react-router-dom";
import FormTextField from "base/FormTextField";
import React, { useState } from "react";

const Signup = () => {
  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const { signUp } = useAuthentication();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Validation
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      setLoading(false);
      return;
    }

    if (!displayName.trim()) {
      setError("Display name is required");
      setLoading(false);
      return;
    }

    try {
      await signUp(email, password, displayName);
      navigate("/"); // Go directly to home (user is now logged in)
    } catch (error) {
      // Handle different error types (no console logging)
      if (error.message.includes("User already registered")) {
        setError(
          "An account with this email already exists. Please login instead.",
        );
      } else if (error.message.includes("Email rate limit exceeded")) {
        setError("Too many signup attempts. Please try again later.");
      } else if (error.message.includes("Invalid email")) {
        setError("Please enter a valid email address.");
      } else if (error.message.includes("Password should be")) {
        setError("Password must be at least 6 characters long.");
      } else {
        // Generic error message
        setError(
          error.message || "Failed to create account. Please try again.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p1">
      <div className="max-w-md mx-auto">
        <h2 className="text-2xl font-bold mb-6">Sign Up</h2>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded">
            <p className="text-red-800 text-sm">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <FormTextField
            fieldLabel="Display Name"
            fieldType="text"
            value={displayName}
            onChange={setDisplayName}
            placeholder="Enter your name"
            required
            disabled={loading}
          />

          <FormTextField
            fieldLabel="Email"
            fieldType="email"
            value={email}
            onChange={setEmail}
            placeholder="Enter your email"
            required
            disabled={loading}
          />

          <FormTextField
            fieldLabel="Password"
            fieldType="password"
            value={password}
            onChange={setPassword}
            placeholder="At least 6 characters"
            required
            disabled={loading}
            fieldSubText="Password must be at least 6 characters"
          />

          <button
            type="submit"
            disabled={loading}
            className="Green p-1 bord-5 Background-LGreen w-100 mb-3"
          >
            {loading ? "Creating account..." : "Sign Up"}
          </button>
        </form>

        <div className="text-center">
          <p className="text-sm">
            Already have an account?{" "}
            <Link to="/login" className="Green">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
